import type { FC, ReactNode } from "react";

interface IndexingRunStatusBannerProps {
  children: ReactNode;
  tone: "error" | "neutral" | "warning";
}

export const IndexingRunStatusBanner: FC<IndexingRunStatusBannerProps> = ({
  children,
  tone,
}) => {
  let toneClass =
    "border-slate-300 bg-slate-50 text-slate-700 dark:border-slate-700 dark:bg-arti-panel dark:text-slate-300";

  if (tone === "error") {
    toneClass =
      "border-rose-200 bg-rose-50 text-rose-700 dark:border-rose-500/40 dark:bg-rose-500/10 dark:text-rose-200";
  } else if (tone === "warning") {
    toneClass =
      "border-amber-200 bg-amber-50 text-amber-700 dark:border-amber-500/40 dark:bg-amber-500/10 dark:text-amber-200";
  }

  return (
    <div className={`rounded-none border px-3 py-2 text-xs ${toneClass}`}>
      {children}
    </div>
  );
};
